var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_BORK/lorem/index.js
// module id = 947
// module chunks = 1